  import Tbl from "./Tbl.js";
  import FilterBlock from "./FilterBlock.js";
  import WithSystem from './../service/WithSystem';

  class OverAllReport extends React.Component {
    constructor(props) {
      super(props);
      this.state = { GlobalState: window.queryFilter} 
    }
    datacallback = (paramdata) => {
    }   

    render() {
      return (<div>
              <div className="container-fluid grade-report-filter nav-content nav-course-content email-tracker">
                <FilterBlock filters={{ ...this.state }} />
              </div>
              <div className="table-report badge-report">
                <Tbl filters={{ ...this.state }} />
            </div>
      </div>)
    }
  }
  export default WithSystem(OverAllReport);